import { format, endOfDay } from 'date-fns';

import type { CourseEntity } from '@modules/courses/entities';
import type { LapCreateArgs, LapFinancialType } from '@modules/types/graphql';

export type CreateLapFormValues = {
    from: Date | null;
    to: Date | null;
    course: CourseEntity | null;
    financialType: string;
    isFree: boolean;
    canCertificate: boolean;
    canStudentEarlyAccess: boolean;
    canStudentViewOLTestResult: boolean;
    studentViewOLTestResultAfterSuccess: boolean;
};

class CreateLapRequest {
    from: LapCreateArgs['from'];
    to: LapCreateArgs['to'];
    courseId: LapCreateArgs['courseId'];
    financialType: LapCreateArgs['financialType'];
    isFree: LapCreateArgs['isFree'];
    canCertificate: LapCreateArgs['canCertificate'];
    canStudentEarlyAccess: LapCreateArgs['canStudentEarlyAccess'];
    canStudentViewOLTestResult: LapCreateArgs['canStudentViewOLTestResult'];
    studentViewOLTestResultAfterSuccess: LapCreateArgs['studentViewOLTestResultAfterSuccess'];

    constructor(values: CreateLapFormValues) {
        this.from = values.from ? format(endOfDay(values.from), 'yyyy-MM-dd') : undefined;
        this.to = values.to ? format(endOfDay(values.to), 'yyyy-MM-dd') : undefined;
        this.courseId = values.course?.id;
        this.financialType = (values.financialType as LapFinancialType) ?? null;
        this.isFree = values.isFree;
        this.canCertificate = values.canCertificate;
        this.canStudentEarlyAccess = values.canStudentEarlyAccess;
        this.canStudentViewOLTestResult = values.canStudentViewOLTestResult;
        this.studentViewOLTestResultAfterSuccess = values.studentViewOLTestResultAfterSuccess;
    }
}

export { CreateLapRequest };
